export default "__VITE_ASSET__CzRreiv7__"